var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10974",
    "data-name": "Group 10974",
    transform: "translate(17877 21367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 24,
    height: 24,
    transform: "translate(-17877 -21367)",
    fill: "#e6e2e2",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20718",
    "data-name": "Path 20718",
    d: "M.344,8.538,0,8l.343-.538C.539,7.157,5.179,0,11.187,0S21.835,7.157,22.03,7.462L22.373,8l-.343.538C21.835,8.843,17.2,16,11.187,16S.539,8.843.344,8.538ZM2.4,8c1.138,1.565,4.719,6,8.783,6s7.646-4.435,8.783-6c-1.138-1.565-4.719-6-8.783-6S3.542,6.434,2.4,8Zm4.8,0a4,4,0,1,1,4,4A4,4,0,0,1,7.207,8Zm2,0a2,2,0,1,0,1.417-1.913A1,1,0,0,1,10.217,8h-.01A1,1,0,0,1,9.3,7.412,1.992,1.992,0,0,0,9.207,8Z",
    transform: "translate(-17876.188 -21363)",
    fill: "#868889"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIcon);
export default __webpack_public_path__ + "static/media/VisibilityIcon.3bb48f9dbd0f37822afb419325fa65e6.svg";
export { ForwardRef as ReactComponent };